const STYLES = {
  "Not Submitted": "bg-slate-100 text-slate-600 border-slate-200",
  Submitted: "bg-blue-50 text-blue-700 border-blue-200",
  "Under Review": "bg-amber-50 text-amber-700 border-amber-200",
  "Needs Correction": "bg-red-50 text-red-700 border-red-200",
  Approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Document Issued": "bg-slate-900 text-white border-slate-900",
  paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  unpaid: "bg-red-50 text-red-700 border-red-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  waived: "bg-slate-100 text-slate-600 border-slate-200",
  refunded: "bg-slate-100 text-slate-600 border-slate-200",
};

export const StatusBadge = ({ status, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${
      STYLES[status] || "bg-slate-100 text-slate-600 border-slate-200"
    }`}
  >
    {status || "—"}
  </span>
);
